/**
 * Removes query string and fragment for indexing metadata. Use at SEO boundaries
 * (e.g. when a canonical is built from `buildExtraParams`), not on hreflang helpers
 * that only concatenate path segments.
 *
 * @param {string | undefined | null} url
 * @returns {string | undefined | null} Same type as input for non-strings; path-only URL for strings
 */
export function stripUrlQueryForIndexing(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }
  const queryIndex = url.indexOf('?');
  const hashIndex = url.indexOf('#');
  let end = url.length;
  if (queryIndex !== -1) {
    end = Math.min(end, queryIndex);
  }
  if (hashIndex !== -1) {
    end = Math.min(end, hashIndex);
  }
  return end === url.length ? url : url.slice(0, end);
}
